import React from "react";
// import logotur from "../image/logotur_rectangle.png";
import logotur from "../image/logotour_2023_transparent.png";
//material UI
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import axios from "axios";
import Button from "@mui/material/Button";
import "../../css/style.css";
import theme from "../../css/theme";

import { useNavigate } from "react-router-dom";
import { user_types } from "../../store/constants/auth";

import { useDispatch, useSelector } from "react-redux";

import { authLogoutSucces } from "../../store/actions/auth";

const Navbar = props => {
  const navigate = useNavigate();

  const currentUser = useSelector(state => state.auth);

  const { user_id, user_type } = currentUser;

  console.log(`current user_type= `, user_type);
  console.log(`Current user logged in: `, user_id);

  const dispatch = useDispatch();

  const handleLogout = () => {
    axios
      .get("/api/public/logout")
      .catch(error => {
        console.error(`Logout error`, error);
      })
      .finally(() => {
        navigate("/");
        dispatch(authLogoutSucces());
      });
  };

  console.log(`currentuser_type: `, currentUser);
  return (
    <Box sx={{ flexGrow: 1, mb: 10 }}>
      <AppBar position="static" className="appbar">
        <Toolbar>
          <a href="/">
            <img src={logotur} alt=" aici trebuia sa apara logo" width={120} />
          </a>
          <div className="navbar-header">Inscrieri Cursa Sponsorilor si Green Day Kids</div>
          {false && (
            <Typography
              className="typography"
              // variant="h4"
              component="div"
              sx={{ flexGrow: 2 }}
            >
              Inscrieri Cursa Sponsorilor si Green Day Kids
            </Typography>
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default Navbar;
